import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { IVehicleData } from "@app/main/components/fleetMaintenance/IVehicleData";
import { VehicleDataService } from "@app/main/components/fleetMaintenance/vehicleData.service";
import { IBrakePerformanceStatus } from "../ebpms/_models/IBrakePerformanceStatus";
import { IDiagnosticRecord } from "../faultCodes/_models/IDiagnosticRecord";
import { IUserFriendlySensorData } from "../sensorData/sensor-data.service";
import './maintenance-vehicle-summary.component.scss';

@Component({
    selector: 'maintenance-vehicle-summary',
    template: require('./maintenance-vehicle-summary.component.html')
})
export class MaintenanceVehicleSummaryComponent implements OnChanges {
    @Input() vehicleId: number;
    @Input() faultCodes: IDiagnosticRecord[];
    @Input() ebpmsStatus: IBrakePerformanceStatus;
    @Input() sensorData: IUserFriendlySensorData[];

    // ---

    selectedVehicleData: IVehicleData;
    vehicleInfo: { title: string, value: string }[] = [];

    constructor(private readonly vehicleDataService: VehicleDataService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getSelectedVehicleData();
    }

    // --

    private async getSelectedVehicleData(): Promise<void> {
        if (!this.vehicleId) {
            return;
        }

        this.vehicleDataService.getDataForVehicle(this.vehicleId).then(vehicleData => {
            this.selectedVehicleData = vehicleData;

            this.createSelectedVehicleInfo();
        });
    }

    private createSelectedVehicleInfo(): void {
        this.vehicleInfo = [];
        if (!this.selectedVehicleData) {
            return
        }

        Object.keys(this.selectedVehicleData).forEach(key => {

            if (this.includeVehicleInfoKey(key)) {
                var data = this.selectedVehicleData[key];
                if (!isNaN(Number(data))) {
                    data = Number(data);
                }

                this.vehicleInfo.push({ title: key.split(/(?=[A-Z])/).join(" "), value: data });
            }
        })
    }

    private includeVehicleInfoKey(key: string): boolean {
        if (this.selectedVehicleData[key] == "") {
            return false;
        }

        const keysToIgnore = ["Id", "VehicleId", "LastUpdated", "MassInService", "TrailerUnbraked", "MaxNetPower", "MaxTechMass"];
        if (keysToIgnore.includes(key)) {
            return false;
        }

        const wildCardsToIgnore = ["Model", "Trailer", "Tax", "Mot", "Model", "Image"];
        return !wildCardsToIgnore.some(pattern => key.includes(pattern));
    }
}

